import { LogOut, LogIn } from 'lucide-react';
import { cardBase, thClass, tdClass, rowClass, fmtDate, ViewAllLink } from './dashboardUtils';

export function MoveInOutWidget({ moveOuts, moveIns, onSelectTenant }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
      <div className={`${cardBase} overflow-hidden`}>
        <div className="flex items-center justify-between px-6 pt-5 pb-3">
          <h2 className="text-[15px] font-semibold text-gray-900 flex items-center gap-2">
            <LogOut className="h-4 w-4 text-red-400" /> Move-Outs
            <span className="text-[11px] font-medium text-gray-400 bg-gray-100 rounded-full px-2 py-0.5 tabular-nums">{moveOuts.length}</span>
          </h2>
          <ViewAllLink to="/move-in-out" label="move-outs" />
        </div>
        {moveOuts.length === 0 ? (
          <p className="px-6 pb-5 text-[13px] text-gray-400">No move-outs this week</p>
        ) : (
          <table className="w-full">
            <thead><tr className="border-b border-gray-100"><th className={thClass}>Tenant</th><th className={thClass}>Unit</th><th className={thClass}>Date</th></tr></thead>
            <tbody>
              {moveOuts.map(t => (
                <tr key={t.id} className={`${rowClass} cursor-pointer`} onClick={() => onSelectTenant(t)} data-testid={`moveout-tenant-${t.id}`}>
                  <td className={`${tdClass} font-medium text-gray-900 hover:text-emerald-700`}>{t.name}</td>
                  <td className={`${tdClass} text-gray-500`}>{t.property_name} {t.unit_number}</td>
                  <td className={`${tdClass} text-gray-500 tabular-nums`}>{fmtDate(t.move_out_date)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      <div className={`${cardBase} overflow-hidden`}>
        <div className="flex items-center justify-between px-6 pt-5 pb-3">
          <h2 className="text-[15px] font-semibold text-gray-900 flex items-center gap-2">
            <LogIn className="h-4 w-4 text-emerald-500" /> Move-Ins
            <span className="text-[11px] font-medium text-gray-400 bg-gray-100 rounded-full px-2 py-0.5 tabular-nums">{moveIns.length}</span>
          </h2>
          <ViewAllLink to="/move-in-out" label="move-ins" />
        </div>
        {moveIns.length === 0 ? (
          <p className="px-6 pb-5 text-[13px] text-gray-400">No move-ins this week</p>
        ) : (
          <table className="w-full">
            <thead><tr className="border-b border-gray-100"><th className={thClass}>Tenant</th><th className={thClass}>Unit</th><th className={thClass}>Date</th></tr></thead>
            <tbody>
              {moveIns.map(t => (
                <tr key={t.id} className={`${rowClass} cursor-pointer`} onClick={() => onSelectTenant(t)} data-testid={`movein-tenant-${t.id}`}>
                  <td className={`${tdClass} font-medium text-gray-900 hover:text-emerald-700`}>{t.name}</td>
                  <td className={`${tdClass} text-gray-500`}>{t.property_name} {t.unit_number}</td>
                  <td className={`${tdClass} text-gray-500 tabular-nums`}>{fmtDate(t.move_in_date)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
